import React from "react";
import DataTablePage from "@/components/common/DataTablePage";

export default function EmailPage() {
  return (
    <DataTablePage
      collection="email_campaigns"
      eyebrow="Retention"
      title="Email & SMS"
      subtitle="Manage lifecycle flows and campaigns — welcome, abandoned cart, post-purchase, replenishment, win-back and subscription conversion."
      emptyMessage="No email campaign data. Connect Klaviyo (AI Comms Manager) to view live flow performance — or log campaigns manually."
      emptyDefault={{ type: "Flow", status: "draft", sent: 0, opens: 0, clicks: 0, revenue: 0 }}
      columns={[
        { key: "name", label: "Name", type: "text" },
        { key: "type", label: "Type", type: "select", options: ["Flow", "Campaign"] },
        { key: "subject", label: "Subject", type: "text" },
        { key: "status", label: "Status", type: "badge", options: ["draft", "scheduled", "live"] },
        { key: "sent", label: "Sent", type: "number" },
        { key: "opens", label: "Opens", type: "number" },
        { key: "clicks", label: "Clicks", type: "number" },
        { key: "revenue", label: "Revenue", type: "money" },
      ]}
    />
  );
}
